import Alpine from 'alpinejs';
import { getCsrfToken } from '../../utils/helpers.js';

Alpine.store('cancellation', {
    step: 'confirm',
    agreed: false,
    loading: false,
    error: '',
    reservationId: '',

    open(reservationId) {
        this.step = 'confirm';
        this.agreed = false;
        this.loading = false;
        this.error = '';
        this.reservationId = reservationId || '';

        Alpine.store('modals').open('cancel-reservation-modal');
    },

    close() {
        Alpine.store('modals').close('cancel-reservation-modal');
    },

    async cancel() {
        this.loading = true;
        this.error = '';

        try {
            const csrf = await getCsrfToken();
            const headers = {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            };
            if (csrf) {
                headers['X-CSRF-Token'] = csrf.value;
            }

            const response = await fetch('/actions/avari/cancellation/cancel', {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    reservationId: this.reservationId
                })
            });

            const data = await response.json();

            if (data.success) {
                this.step = 'success';
            } else {
                this.error =
                    data.error || 'Something went wrong. Please try again.';
            }
        } catch {
            this.error = 'Something went wrong. Please try again.';
        } finally {
            this.loading = false;
        }
    }
});
